import {combineReducers} from 'redux';
import details from './details/reducer';
import information from './information/reducer';

export default combineReducers({
  details,
  information,
});
